import api from "@/services/api";

const reportTransportExpiredService = {
  getList(params) {
    return api.get("/report/transport-expired", { params });
  },

  exportExcel(params) {
    return api.get("/report/transport-expired/export-excel", {
      params,
      responseType: "blob",
    });
  },
};

export default reportTransportExpiredService;